import { API_BASE_URL } from './api';
import { getToken } from './auth';

export type DonationFrequency = 'one_time' | 'monthly' | 'sponsor_project' | 'corporate';

export type Donation = {
  id: number;
  amount: string;
  frequency: DonationFrequency;
  project_label: string | null;
  message: string | null;
  created_at: string;
};

function authHeaders() {
  const token = getToken();
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

export async function createDonation(payload: {
  amount: number;
  frequency: DonationFrequency;
  projectLabel?: string;
  message?: string;
}): Promise<Donation> {
  const res = await fetch(`${API_BASE_URL}/donations`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.message || `Could not record your gift (${res.status})`);
  }

  const body = await res.json();
  return body.data;
}

export async function listMyDonations(): Promise<{ data: Donation[]; total: number }> {
  const res = await fetch(`${API_BASE_URL}/donations/me`, { headers: authHeaders() });
  if (!res.ok) throw new Error('Could not load your donations');
  return res.json();
}
